// TODO: tech debt, refactor it, priority: medium. Also move to shared folder and create common css
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Link from 'shared/components/Link';
import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import { ContactPhoneButton, TagButton } from 'shared/components/UI';
import withStatsEvents from 'shared/hocs/stats/withStatsEvents';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import DealerServiceForm from 'shared/components/DealerServiceForm/DealerServiceForm';
import ThanksBlock from 'shared/components/DealerServiceForm/ThanksBlock';
import { withTranslate } from 'shared/hocs/withTranslate';

import IconIsChecked from 'shared/assets/icons/dealer/isChecked.svg';
import IconTradeIn from 'shared/components/DealerItem/Icons/TradeIn';
import IconTestDrive from 'shared/components/DealerItem/Icons/TestDrive';
import IconIsGuarantee from 'shared/assets/icons/dealer/guarantee.svg';
import { fireRTBEvent } from 'shared/helpers/rtbHouse';
// import { IsVerifiedElement } from 'shared/components/Elements';

import s from './DealerItem.css';

class DealerItem extends React.Component {
  static propTypes = {
    dealer: PropTypes.shape({}).isRequired,
    events: PropTypes.shape({}).isRequired,
    setRatioImage: PropTypes.func.isRequired,
    type: PropTypes.string,
    url: PropTypes.string,
    //
    t: PropTypes.func.isRequired,
    setDataLayer: PropTypes.func.isRequired,
  };

  static defaultProps = {
    type: 'dealer',
    url: null,
  };

  state = {
    emailSent: false,
    showDealerServiceModal: false,
    currentService: '',
  };

  onEmailSent = serviceType => {
    this.setState({ emailSent: true });
    setTimeout(() => {
      this.closeServiceModal();
    }, 5000);

    const eventName = { 'Trade-in': 'formTradeIn', 'Тест-драйв': 'formTestDrive' };
    const gtmEvent = EVENTS.DEALERS[eventName[serviceType]];
    if (gtmEvent) this.props.setDataLayer(gtmEvent);

    fireRTBEvent(eventName[serviceType], {
      ids: [this.props.dealer.slug],
    });
  };

  handleShowPhonesClick = () => {
    const { dealer: { id }, events } = this.props;
    events.dispatchDealerShowPhoneEvent(id);
    this.props.setDataLayer(EVENTS.DEALERS.showNubmer);
    fireRTBEvent('showNubmer', {
      ids: [this.props.dealer.slug],
    });
  };

  handleAllAdvertsClick = () => {
    this.props.setDataLayer(EVENTS.showAllDealerAdverts);
  };

  handleRemovalModalClose = () => {
    this.setState({ isDeactivateModalOpen: false, isRemovalModalOpened: false });
  };

  openServiceModal = (event, serviceType) => {
    this.setState({
      showDealerServiceModal: true,
      currentService: serviceType,
    });
    const eventName = { 'Trade-in': 'tradeIn', 'Тест-драйв': 'testDrive' };
    const gtmEvent = EVENTS.DEALERS[eventName[serviceType]];
    if (gtmEvent) this.props.setDataLayer(gtmEvent);
  };

  closeServiceModal = () => {
    this.setState({
      showDealerServiceModal: false,
      emailSent: false,
    });
  };

  render() {
    const { dealer, url: urlPrefix, setRatioImage, t } = this.props;
    const url = urlPrefix ? `${urlPrefix}${dealer.slug}/` : `/avtosalony/${dealer.slug}/`;
    const {
      title,
      logo,
      address,
      phones,
      adverts_count: advertsCount = t('Нет'),
      is_official: isOfficial = false,
      is_verified: isVerified,
      association_guarantees: isGuarantee,
      tariff_vip: isVip,
      tariff_standart: isStandart,
      tariff_start: isStart,
      test_drive: testDrive,
      trade_in: tradeIn,
    } = dealer;

    const tags = [
      {
        title: t('Тест-драйв'),
        icon: IconTestDrive,
        available: testDrive,
      },
      {
        title: 'Trade-in',
        icon: IconTradeIn,
        available: tradeIn,
      },
    ];

    const IMAGE_WIDTH = 100;

    const logoImg = logo && setRatioImage(logo.replace('http:', 'https:'), IMAGE_WIDTH);

    /* const locale = t('locale') === 'ru' ? '' : `${t('locale')}_`;
    const agreementLink = `/pdf/${locale}terms-of-use.pdf`; */

    return (
      <div className={cx(s.root, { [s.isVip]: isVip, [s.isStandart]: isStandart })}>
        {isVip &&
          <span className={s.vipBadge}>
            ТОП
          </span>}
        <div className={s.left}>
          <div className={s.logo}>
            <Link to={url}>
              <img className={s.img} src={logoImg} width={IMAGE_WIDTH} alt="" />
            </Link>
          </div>
        </div>
        <div className={s.right}>
          <div className={s.titleWithButton}>
            <div>
              {isVerified &&
                <div className={s.isVerified}>
                  <img src={IconIsChecked} className={s.isVerifiedIcon} alt="Проверенный партнёр" />
                  <FormattedMessage id="Проверенный партнёр" />
                </div>}
              {isGuarantee &&
                <div className={s.isGuarantee}>
                  <img
                    src={IconIsGuarantee}
                    className={s.isGuaranteeIcon}
                    alt="Ассоциация гарантирует"
                  />
                  <FormattedMessage id="Ассоциация гарантирует" />
                </div>}

              <div className={s.title}>
                <Link className={s.link} to={url}>
                  {title}
                </Link>
              </div>

              {isOfficial &&
                <div className={s.isOfficial}>
                  <FormattedMessage id="Официальный дилер" />
                </div>}
              <div className={s.adr}>
                {address}
              </div>
            </div>
            <div className={s.contactPhoneButton}>
              <ContactPhoneButton clickHandler={this.handleShowPhonesClick} phones={phones} />
            </div>
          </div>

          <div className={s.tags}>
            {tags.map(item => {
              return (
                <TagButton
                  key={item.title}
                  title={item.title}
                  clickHandler={this.openServiceModal}
                  Icon={item.icon}
                  disabled={!item.available}
                />
              );
            })}
          </div>

          <div className={s.adverts}>
            <Link onClick={this.handleAllAdvertsClick} to={url} className={s.allAdvertsLink}>
              {advertsCount} <FormattedMessage id="предложений" />
            </Link>
          </div>

          {this.state.showDealerServiceModal &&
            <div>
              <ModalContainer
                modalCN={s.modal}
                onClose={this.closeServiceModal}
                isOpen={this.state.showDealerServiceModal}
              >
                <div className={s.rootModal}>
                  <div className={s.rootModalBody}>
                    {this.state.emailSent
                      ? <ThanksBlock />
                      : <React.Fragment>
                          <h3 className={s.rootModalTitle}>
                            <FormattedMessage id="Заявка на" /> {this.state.currentService}
                          </h3>
                          <DealerServiceForm
                            dealerSlug={dealer.slug}
                            service={this.state.currentService}
                            onSent={() => this.onEmailSent(this.state.currentService)}
                          />
                          <p className={`${s.modalText} ${s.rootModalPolicy}`}>
                            <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_1" />
                            <br />
                            <Link className={s.modalTextLink}>
                              {/* eslint-disable-next-line no-script-url */}
                              {''}
                              <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_2" />
                            </Link>
                          </p>
                        </React.Fragment>}
                    <i
                      className={cx({
                        'fa fa-times': true,
                        [s.closeBtnIcon]: true,
                      })}
                      onClick={this.closeServiceModal}
                    />
                  </div>
                </div>
              </ModalContainer>
            </div>}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(
  connect(null, { setDataLayer })(withTranslate(withStatsEvents(withPixelRatio(DealerItem)))),
);



// WEBPACK FOOTER //
// ./src/shared/components/DealerItem/DealerItem.js